import React from 'react'

import { Heading } from './Heading'
import { ReactComponent as WTWLogoSVG } from '../assets/wtw-logo.svg'

import { Box, Flex, SVG, Text } from 'system'

export const DocsForm = React.forwardRef(
  ({ handleSubmit, heading, description, children, ...props }, ref) => (
    <Box
      p={4}
      bg="white"
      borderRadius="8px"
      border="1px solid"
      borderColor="purple.90"
      width={['auto', '28rem']}
      {...props}
    >
      <Box mb={4}>
        <SVG x={1} y={1} svg={WTWLogoSVG} width="6rem" mb={3} mx="auto" />
        <Heading fontSize="large" textAlign="center" mb={1}>
          {heading}
        </Heading>
        <Text textAlign="center" color="gray.30" lineHeight="copy">
          {description}
        </Text>
      </Box>

      <Flex
        as="form"
        flexDirection="column"
        alignItems="center"
        onSubmit={handleSubmit}
        ref={ref}
      >
        {children}
      </Flex>
    </Box>
  ),
)

export default DocsForm
